import BuildingIcon from '../../../icons/building.svg'
import BuildingsGroupIcon from '../../../icons/buildings-group.svg'
import FaqIcon from '../../../icons/faq.svg'
import ReplyIcon from '../../../icons/reply.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import TaskIcon from '../../../icons/task.svg'

export const PROMPT_ICON = {
  'default-at-address': BuildingIcon,
  'default-capabilities': FaqIcon,
  'default-draft-reply': ReplyIcon,
  'default-my-requests': ServiceRequestIcon,
  'default-today-first': TaskIcon,
  'default-top-building': BuildingsGroupIcon,
}
